import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    equipmentState: null,
  },
  getters: {
    equipmentState: (state) => state.equipmentState,
  },
  mutations: {
    SET_EQUIPMENT_STATE: (state, equipment) => {
      state.equipmentState = equipment;
    },
  },
  actions: {
    getEquipmentState({ commit }) {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      // null PC端，另一个移动端
      commit("SET_EQUIPMENT_STATE", flag);
    },
  },
  modules: {},
});
